// src/pages/SuperAdmin/Users/userApi.js
import api from "../../../components/axiosComp";

// LIST (optional server search/pagination)
export const listUsers = (params) =>
  api.get("/api/superAdmin/users", { params });

// CREATE (SA)
export const createUser = (payload) =>
  api.post("/api/superAdmin/users", payload);

// READ BY ID (for future edit/view)
export const getUserById = (id) => api.get(`/api/superAdmin/users/${id}`);

// UPDATE (for future edit)
export const updateUser = (id, payload) =>
  api.put(`/api/superAdmin/users/${id}`, payload);

// DELETE (SA)
export const deleteUser = (id) => api.delete(`/api/superAdmin/users/${id}`);
